import { useState } from "react";
import { ReactLenis } from "lenis/react";
import { AnimatePresence } from "framer-motion";
import Preloader from "@/components/Preloader";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/Marquee";
import Services from "@/components/Services";
import HorizontalPortfolio from "@/components/HorizontalPortfolio";
import Manifesto from "@/components/Manifesto";
import Studio from "@/components/Studio";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Home() {
  const [intro, setIntro] = useState(true);

  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <AnimatePresence>
        {intro && <Preloader key="preloader" onDone={() => setIntro(false)} />}
      </AnimatePresence>

      <div className="relative bg-black">
        <Navbar />
        <main>
          <Hero start={!intro} />
          <EditorialMarquee />
          <Services />
          <HorizontalPortfolio />
          <Manifesto />
          <Studio />
          <Contact />
        </main>
        <Footer />
      </div>
    </ReactLenis>
  );
}
